import React, { useEffect } from 'react';
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import BaseModal from '@components/ui/BaseModal';
import { ModalSuccessPropsInterface } from './ModalSuccessTypes';
import Actions from './Actions';
import * as Styled from './ModalSuccessStyles';

function ModalSuccess({
  baseModalRef,
  contentModalRef,
  isShow,
  onClose,
  onNewJourney,
}: ModalSuccessPropsInterface) {
  const { amplitudeEvent } = useAmplitude();

  useEffect(() => {
    if (isShow) {
      amplitudeEvent('journey_create_modal_success_viewed');
    }
  }, [isShow]);

  return (
    <BaseModal
      isOpen={isShow}
      onClose={() => onClose()}
      innerRef={baseModalRef}
      hOverlay
    >
      <Styled.Wrapper ref={contentModalRef}>
        <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km6' }}>
          <FuelFlex defaultProps={{ justifyContent: 'center' }}>
            <Styled.WrapperIcon>
              <FuelIcon name="one-check" size="medium" />
            </Styled.WrapperIcon>
          </FuelFlex>
          <div>
            <FuelTypography tag="h3" size="body-lg" weight="bold">
              Viagem criada!
            </FuelTypography>
            <FuelTypography
              size="body-md"
              weight="medium"
              color="neutral-default"
              spacingTop={8}
            >
              Agora, é só aguardar o motorista aceitar a viagem para iniciar o
              monitoramento.
            </FuelTypography>
          </div>
          <Actions onClose={onClose} onNewJourney={onNewJourney} />
        </FuelFlex>
      </Styled.Wrapper>
    </BaseModal>
  );
}

export default ModalSuccess;
